export default __webpack_public_path__ + "static/media/desktop_add_new.013f50b4.svg";